<template>
    <b-modal :id="id" size="xl" @ok="handleOk" @deleteAddress="deleteAddress" @createAddressOk="createAddress">
        <template v-slot:modal-title>
            {{ $t('editAddress.modal.title') }}
            <font-awesome-icon icon="edit"></font-awesome-icon>
        </template>

        <form ref="form" @submit.stop.prevent="handleOk">
            <b-form-group>
                <b-row>
                    <b-col>
                        <addressEdit
                          :address="address"
                          :refPrefix="refPrefix"
                          :v="validation"
                          :isEditAddress="true"
                          :show-vat-number="true"
                          v-if="refPrefix !== 'editModalsoldToAddress'"
                        />
                        <addressEdit
                          :address="address"
                          :refPrefix="refPrefix"
                          :v="validation"
                          :isEditAddress="true"
                          :show-account-number="true"
                          :show-duty-account-number="true"
                          :show-eori-number="true"
                          :show-vat-number="true"
                          v-if="refPrefix === 'editModalsoldToAddress'"
                        />
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-invalid-feedback
                name="editAddressInvalidFeedback"
                v-if="invalidFeedback"
                :state="!state"
            >{{ invalidFeedback }}</b-form-invalid-feedback>
        </form>

        <template v-slot:modal-footer="{ ok }">
            <b-button @click="displayConfirmModal()" name="deleteAddressButton">
                <font-awesome-icon icon="trash-alt" />
                {{ $t('editAddress.button.deleteAddress') }}
            </b-button>
            <b-button
                @click="ok()"
                variant="primary"
                name="updateAddressButton"
            >
                <font-awesome-icon icon="save" />
                {{ $t('editAddress.button.updateAddress') }}
            </b-button>
          <b-button
              @click="createAddress()"
              variant="primary"
              name="createAddressButton"
          >
            <font-awesome-icon icon="save" />
            {{ $t('editAddress.button.createAddress') }}
          </b-button>
        </template>

        <confirmModal
            ref="deleteAddressConfirmModal"
            @confirmAction="deleteAddress"
            okButtonName="deleteAddressConfirmButton"
        />
    </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex';
  import axios from 'axios';
  import vSelect from './vSelect';
  import { ifError } from 'assert';
  import { ACTIONS, MUTATIONS, CREATE_SHIPMENT_PREFIX } from '../store/constants';
  import { requiredIf, required, maxLength } from 'vuelidate/lib/validators';
  import validationField from './Validation/ValidationField';
  import helpers from '@/helper';
  import addressValidation from '../validators/editAddressValidation';
  import confirmModal from './confirmModal';
  import _ from 'lodash';

  export default {
      components: {
          vSelect,
          confirmModal,
          addressEdit: () => import('./address'),
      },

      validations: {
          address: addressValidation,
      },

      props: {
          refPrefix: {
              type: String,
          },

          addressToEdit: {
              type: Object,
              required,
          },
      },

      watch: {
          addressToEdit: {
              handler() {
                  this.address = this.addressToEdit;
              },
          },
      },

      data() {
          return {
              address: null,
              invalidFeedback: '',
          };
      },

      computed: {
          validation() {
              return this.$v.address;
          },

          state() {
              return this.$v.$anyError;
          },
      },
      methods: {
          handleOk(bvModalEvt) {
              bvModalEvt.preventDefault();
              this.updateAddress();
          },

          updateAddress() {
              this.$v.$touch();

              if (this.$v.$anyError) {
                  this.invalidFeedback = 'Please correct validaton errors';
                  return;
              }

              this.$emit('updateAddress', this.address);

              this.$nextTick(() => {
                  this.$bvModal.hide(this.id);
              });
          },

          createAddress() {
            this.$v.$touch();

            if (this.$v.$anyError) {
              this.invalidFeedback = 'Please correct validaton errors';
              return;
            }

            this.$emit('createAddress', this.address);

            
            // this.$nextTick(() => {
            //   this.$bvModal.hide(this.id);
            // });
          },

          deleteAddress() {
              this.$emit('deleteAddress', this.address.addressId);

              this.$bvModal.hide(this.id);
          },
          displayConfirmModal() {
              this.$refs['deleteAddressConfirmModal'].show();
          },
      },

      created() {
          this.id = this.refPrefix + '_edit-address-modal';
      },
    
  };
</script>
